let tips = {
  number:''
};

const inputAmountRules = ( rules, val, callback ) =>{
  const rex = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
  if( rex.test(val) ){
    callback()
  }else{
    callback(new Error('请输入正确金额'))
  }
};
const inputIdCardRules = ( rules, val, callback ) =>{
    const idCardReg=/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
    if( idCardReg.test(val) ){
        callback()
    }else{
        callback(new Error('请输入正确的身份证号码'))
    }
};
const inputChineseRules = ( rules, val, callback ) =>{
    const reg=/^[\u4e00-\u9fa5]/;
    if( reg.test(val) ){
        callback()
    }else{
        callback(new Error('请输入正确的信息'))
    }
};
const numberRules = ( rules, val, callback ) => {
  const rex = /^\d+$/;
  if( rex.test(val) ){
    callback()
  }else{
    callback(new Error('请输入正确的' + tips.number))
  }
}
const number = ( tip = '数量' ) => {
  if( tip ) tips.number = tip;
  return [
    {required: true, message: `请输入${tip}`, trigger: 'blur'},
    { validator: numberRules, trigger: 'blur' }
  ];
}

const required = (tip = '请输入内容',isRequired = true , type = {}) => [
    {...type, required: isRequired, message: tip, trigger: 'blur' }
  ];

const amount = (tip = '请输入金额' ) => [
  {required: true, message: tip, trigger: 'blur'},
  {validator: inputAmountRules, trigger: 'blur' }
];
const idCard = (tip = '请输入身份证号码' ) => [
    {required: true, message: tip, trigger: 'blur'},
    {validator: inputIdCardRules, trigger: 'blur' }
];
const chinese = (tip = '请输入中文' ) => [
    {required: true, message: tip, trigger: 'blur'},
    {validator: inputChineseRules, trigger: 'blur' }
];
export default {
  required,
  amount,
  number,
  idCard,
  chinese
}
